import React, { Component } from 'react'
import '../../card.css'

class CardContainer extends Component {

    render() {
        return (
            <div class="cards-holder-container">
                {this.props.children}
            </div >
        )
    }
}

export default CardContainer